import { getUrl } from "aws-amplify/storage";

/**
 * Given the s3 key, gets the object from storage that we want to render
 * @author Eric Webb <ewebb@factorearth.com>
 * @param key The get for the s3 object
 * @returns The url that we can render in the app
 */
export async function getCorrectS3Url(key: string): Promise<string> {
	if (key) {
		const retrievedUrl = await getUrl({ key });
		const actualUrl = retrievedUrl.url.toString();
		return actualUrl;
	}
	// Empty string
	return key;
}
